import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function LegacySclaApplicationRedirect() {
  const { pathname, search, hash } = useLocation();
  const nextPath = pathname.replace(/^\/application(?=\/|$)/, '/scla-application');

  return <Navigate to={`${nextPath}${search}${hash}`} replace />;
}
